import IndexTable from '@lib/components/index-table/IndexTable'
import ConfigurationIndexTableRow from '../configurations/ConfigurationIndexTableRow'


export default class ConfiguratinsTable extends IndexTable {

    rowComponentClass = ConfigurationIndexTableRow
}
